module.exports = __webpack_public_path__ + "fonts/iconfont.8db78111.ttf";